var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-row"},[_c('span',{staticClass:"order-row__label"},[_vm._v("\n         "+_vm._s(_vm.label)+":\n    ")]),_c('span',{staticClass:"order-row__data"},[_vm._v("\n         "+_vm._s(_vm.data)+"\n    ")]),(_vm.active)?_c('span',{staticClass:"order-row__active"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }